import React, { useState, useEffect } from "react";
import Pill from "../../Pill/pill";
import Button from "../../Buttons/button";
import RadioButton from "../../RadioButton/RadioButton";
import {
  companySubmissionDetail,
  selectCompanyDashboard,
} from "../../../redux/slices/companyDashboardSlice";
import {
  getUserExpenses,
  createExpensesComments,
  getUserExpensesComments,
  selectPersonalDashboard,
  statusUpdateSubmission,
} from "../../../redux/slices/personalDashboardSlice";
import { selectUser } from "../../../redux/slices/userSlice";

import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../modules/feedbacker/feedback-module/feedbackModule";
import { getInitials } from "../../../shared/lib/getInitials";
import { useFormattedAmount } from "../../../hooks/useFormattedAmount";

function ExpenseInfoModel({ show, setShow, expense_id, expensesData }) {
  const [status, setStatus] = useState("open");
  const [Words, setWords] = useState("");
  const [openbutton, setOpenbutton] = useState(false);
  const [commentsData, setCommentsData] = useState(false);
  const userData = useSelector(selectUser);
  const personalData = useSelector(selectPersonalDashboard);
  const dispatch = useDispatch();
  const formatFunction = useFormattedAmount();
  const State = useSelector(selectCompanyDashboard);
  const { userExpensesComment, expensesCommentData } = personalData;
  const { companySubmissionDetailData } = State;
  const { submission } = companySubmissionDetailData || {};
  const { userDetails } = userData;
  const user_id = userDetails?.user?.id;
  const [data, setData] = useState([]);

  const personalState = useSelector(selectPersonalDashboard);
  const transformedData = transformResponse(expensesData);

  function transformResponse(response = [], expense_id) {
    const item = response?.find((item) => item.id === expense_id);
    if (!item) return null;

    return {
      id: item.id,
      expense_name: item.title,
      expense_category: item.category,
      employee_name: item.employee?.name || "",
      employee_role: item.employee?.distinction || "",
      cost: item.cost,
      expensed_date: item.expensed_date,
      transaction_date: item.transaction_date,
      reason: item.reason_for_expense || "No reason provided",
    };
  }

  useEffect(() => {
    if (expensesData?.length && expense_id) {
      const transformedData = transformResponse(expensesData, expense_id);
      setData(transformedData);
    }
  }, [expensesData, expense_id]);

  useEffect(() => {
    if (expense_id) {
      dispatch(getUserExpensesComments(expense_id, user_id));
    }
  }, [dispatch, expensesCommentData, expense_id]);

  const request_type = "change";
  const reason_type = "better_suites";

  // useEffect(() => {
  //   dispatch(companySubmissionDetail(id.id, id.user_id));
  //   setOpenbutton();
  //   setCommentsData(false);
  // }, [commentsData, openbutton, id.id, id.user_id, dispatch]);

  const postComment = () => {
    dispatch(
      createExpensesComments(expense_id, {
        comment: {
          user_id: user_id,
          content: Words,
        },
      })
    );
    setCommentsData(true);
    setWords("");
  };

  const initials = getInitials("Eleanor Pena");

  const handleStatus = (value) => {
    setStatus(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      postComment();
    }
  };

  return (
    <div
      className={`flex flex-col bg-[#363D50] rounded-[24px] relative w-full sm:w-[350px] scrollbar-hide md:w-[591px] lg:w-[591px] xl:w-[591px] 2xl:w-[591px] overflow-y-scroll scrollbar-hide`}
    >
      <div className="sticky left-0 right-0 top-0 bg-[#363D50]">
        <div className="flex items-center justify-between p-3 md:px-[24px] md:py-[16px]">
          <div className="flex flex-start items-center gap-2 md:gap-[16px]">
            <div className="flex justify-center items-center bg-[#596073] w-[40px] h-[40px] rounded-[8px]">
              {data?.expense_category === "flight" && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.98276 20.048L7.89276 16.102L3.92676 13.992L5.00976 12.915L8.46176 13.502L11.5118 10.452L4.00976 7.25L5.39776 5.87L14.5228 7.435L17.6428 4.296C17.9228 4.01533 18.2661 3.875 18.6728 3.875C19.0794 3.875 19.4228 4.01533 19.7028 4.296C19.9841 4.57667 20.1248 4.91933 20.1248 5.324C20.1248 5.72867 19.9844 6.07133 19.7038 6.352L16.5588 9.477L18.1248 18.597L16.7308 19.991L13.5418 12.489L10.4918 15.539L11.0648 18.966L9.98276 20.048Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "hotel" && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 19V4H3V14H11V6H19C20.1 6 21.0417 6.39167 21.825 7.175C22.6083 7.95833 23 8.9 23 10V19H21V16H3V19H1ZM7 13C6.16667 13 5.45833 12.7083 4.875 12.125C4.29167 11.5417 4 10.8333 4 10C4 9.16667 4.29167 8.45833 4.875 7.875C5.45833 7.29167 6.16667 7 7 7C7.83333 7 8.54167 7.29167 9.125 7.875C9.70833 8.45833 10 9.16667 10 10C10 10.8333 9.70833 11.5417 9.125 12.125C8.54167 12.7083 7.83333 13 7 13Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "transportation" && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM4.205 13.81C4.55496 15.3124 5.33129 16.6817 6.44071 17.7536C7.55013 18.8254 8.94545 19.554 10.459 19.852C10.266 17.227 9.403 15.652 8.313 14.781C7.269 13.946 5.853 13.623 4.205 13.809V13.81ZM15.687 14.78C14.597 15.653 13.734 17.227 13.541 19.852C15.0547 19.554 16.4501 18.8252 17.5595 17.7531C18.669 16.6811 19.4452 15.3116 19.795 13.809C18.147 13.623 16.731 13.946 15.687 14.781V14.78ZM12 4C10.136 3.99967 8.33043 4.65023 6.89502 5.83935C5.4596 7.02847 4.48447 8.6815 4.138 10.513L4.095 10.761L6.305 10.319C6.887 10.203 7.44 9.896 8.058 9.479L8.535 9.147C9.332 8.581 10.513 8 12 8C13.388 8 14.509 8.506 15.3 9.034L15.942 9.479C16.482 9.844 16.974 10.124 17.478 10.267L17.695 10.319L19.905 10.761C19.6096 8.87675 18.6508 7.16003 17.2013 5.92036C15.7519 4.68069 13.9073 3.99964 12 4Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "meal" && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.50512 13.2875C7.52312 13.3025 10.3901 10.4385 10.3901 10.4065C10.3901 10.3745 5.34312 5.33254 4.08112 4.09954C3.61912 3.64954 3.21912 3.27954 3.19612 3.27954C3.1134 3.32454 3.04062 3.38576 2.98212 3.45954C2.64284 3.83519 2.3866 4.27816 2.23012 4.75954C2.17112 4.92854 2.13012 5.06754 2.13012 5.06754C2.12517 5.11745 2.11648 5.16693 2.10412 5.21554C1.97919 5.76882 1.96762 6.34167 2.07012 6.89954C2.28312 7.91554 2.59712 8.35954 4.38312 10.1635C4.97312 10.7615 7.40012 13.1845 7.50512 13.2875ZM14.4001 11.6585C14.4761 11.6845 14.5447 11.7284 14.6001 11.7865C14.8042 11.9783 15.0446 12.1271 15.3072 12.2243C15.5697 12.3215 15.8491 12.365 16.1288 12.3524C16.4086 12.3397 16.6829 12.271 16.9356 12.1505C17.1883 12.0299 17.4143 11.8599 17.6001 11.6505C17.9911 11.3125 18.1891 11.1195 20.1001 9.21554L22.0001 7.31954L21.5231 6.83754C21.2631 6.57054 21.0431 6.35754 21.0371 6.36354C21.0311 6.36954 20.2791 7.11554 19.3671 8.02454L17.7081 9.68054L17.2341 9.21254C17.0693 9.05562 16.9105 8.8925 16.7581 8.72354C16.7581 8.71454 17.5011 7.95654 18.4131 7.04454L20.0661 5.38554L19.6001 4.90854C19.4436 4.74441 19.2815 4.58565 19.1141 4.43254C19.1051 4.43254 18.3501 5.17854 17.4381 6.08754L15.7741 7.74654L15.2891 7.26654L14.8031 6.78654L16.4611 5.12854C17.0198 4.57518 17.5728 4.01615 18.1201 3.45154C18.1201 3.44254 17.5451 2.85154 17.2551 2.57254L17.1551 2.47754L16.1901 3.46054C14.2291 5.46554 13.3581 6.36954 12.8641 6.92054C12.7691 7.02654 12.6801 7.12054 12.6711 7.12754C12.6077 7.19539 12.5467 7.26544 12.4881 7.33754C12.2992 7.58849 12.1788 7.88429 12.1388 8.19585C12.0989 8.50742 12.1407 8.82402 12.2601 9.11454C12.3672 9.37389 12.5013 9.62125 12.6601 9.85254C12.6721 9.86154 12.7341 9.92654 12.8001 9.99454L12.9181 10.1185L7.94912 15.0915L2.97912 20.0615L3.70212 20.7905L4.42212 21.5215L7.97612 17.9675L11.5271 14.4165L15.0581 17.9465C16.2394 19.1319 17.4261 20.3119 18.6181 21.4865C18.6331 21.4925 20.0181 20.1265 20.0391 20.0705C20.0451 20.0555 18.4581 18.4505 16.5121 16.5045L12.9751 12.9655L13.5231 12.4235C14.2641 11.6885 14.3001 11.6585 14.4001 11.6585Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "office supplies" && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3L13 9L15 11L22 4V3M12 12.5C11.8674 12.5 11.7402 12.4473 11.6464 12.3536C11.5527 12.2598 11.5 12.1326 11.5 12C11.5 11.8674 11.5527 11.7402 11.6464 11.6464C11.7402 11.5527 11.8674 11.5 12 11.5C12.1326 11.5 12.2598 11.5527 12.3536 11.6464C12.4473 11.7402 12.5 11.8674 12.5 12C12.5 12.1326 12.4473 12.2598 12.3536 12.3536C12.2598 12.4473 12.1326 12.5 12 12.5ZM6 20C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18C4 17.4696 4.21071 16.9609 4.58579 16.5858C4.96086 16.2107 5.46957 16 6 16C6.53043 16 7.03914 16.2107 7.41421 16.5858C7.78929 16.9609 8 17.4696 8 18C8 18.5304 7.78929 19.0391 7.41421 19.4142C7.03914 19.7893 6.53043 20 6 20ZM6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8ZM9.64 7.64C9.87 7.14 10 6.59 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C6.59 10 7.14 9.87 7.64 9.64L10 12L7.64 14.36C7.14 14.13 6.59 14 6 14C4.93913 14 3.92172 14.4214 3.17157 15.1716C2.42143 15.9217 2 16.9391 2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22C7.06087 22 8.07828 21.5786 8.82843 20.8284C9.57857 20.0783 10 19.0609 10 18C10 17.41 9.87 16.86 9.64 16.36L12 14L19 21H22V20L9.64 7.64Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "cell phone plan" && (
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5 1C11.5 1 13.834 1.212 16.803 4.182C19.773 7.152 19.985 9.485 19.985 9.485M12.207 4.536C12.207 4.536 13.197 4.818 14.682 6.303C16.167 7.788 16.45 8.778 16.45 8.778"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M13.645 14.543L14.1 14.063L13.012 13.03L12.557 13.511L13.645 14.543ZM15.599 13.861L17.509 14.962L18.258 13.661L16.347 12.561L15.599 13.861ZM17.878 17.241L16.458 18.736L17.545 19.77L18.965 18.275L17.878 17.241ZM15.603 19.216C14.168 19.357 10.423 19.237 6.359 14.959L5.272 15.991C9.701 20.654 13.926 20.89 15.75 20.709L15.603 19.216ZM6.359 14.959C2.483 10.878 1.833 7.43503 1.752 5.92503L0.254001 6.00603C0.354001 7.85603 1.138 11.639 5.272 15.991L6.359 14.959ZM7.735 8.32103L8.021 8.01903L6.934 6.98603L6.647 7.28803L7.735 8.32103ZM8.247 4.25903L6.986 2.47703L5.761 3.34303L7.021 5.12603L8.247 4.25903ZM2.717 2.09103L1.149 3.74503L2.237 4.77803L3.807 3.12503L2.717 2.09103ZM7.191 7.80403C7.01103 7.63057 6.82936 7.4589 6.646 7.28903L6.644 7.29103L6.641 7.29403L6.591 7.35203C6.49308 7.48185 6.41552 7.62583 6.361 7.77903C6.263 8.05403 6.211 8.41803 6.277 8.87203C6.407 9.76403 6.992 10.963 8.519 12.572L9.607 11.538C8.179 10.035 7.827 9.11003 7.761 8.65403C7.729 8.43403 7.761 8.31903 7.774 8.28203L7.782 8.26303L7.754 8.30003L7.736 8.32003C7.736 8.32003 7.734 8.32003 7.191 7.80403ZM8.519 12.572C10.042 14.176 11.192 14.805 12.069 14.948C12.52 15.021 12.885 14.962 13.161 14.853C13.3141 14.7933 13.4563 14.7089 13.582 14.603L13.618 14.569L13.632 14.555L13.639 14.549L13.642 14.546L13.643 14.544C13.643 14.544 13.645 14.543 13.101 14.026C12.557 13.51 12.558 13.509 12.558 13.508L12.56 13.507L12.562 13.504L12.567 13.499L12.577 13.489L12.614 13.457C12.624 13.4517 12.6227 13.452 12.61 13.458C12.59 13.466 12.5 13.498 12.31 13.467C11.908 13.401 11.04 13.047 9.607 11.538L8.519 12.572ZM6.986 2.47703C5.972 1.04303 3.944 0.800028 2.718 2.09203L3.804 3.12503C4.327 2.57503 5.249 2.61803 5.761 3.34303L6.986 2.47703ZM1.752 5.92503C1.73 5.52503 1.905 5.12603 2.237 4.77803L1.149 3.74503C0.613001 4.30903 0.205001 5.09203 0.254001 6.00603L1.752 5.92503ZM16.457 18.737C16.178 19.031 15.887 19.188 15.603 19.216L15.75 20.709C16.497 20.636 17.102 20.237 17.545 19.77L16.457 18.737ZM8.021 8.02003C8.989 7.00103 9.057 5.40703 8.247 4.26003L7.022 5.12603C7.444 5.72303 7.379 6.51803 6.934 6.98603L8.021 8.02003ZM17.509 14.962C18.33 15.435 18.491 16.597 17.878 17.242L18.965 18.275C20.27 16.901 19.89 14.601 18.258 13.661L17.509 14.962ZM14.1 14.064C14.485 13.658 15.086 13.567 15.599 13.862L16.347 12.562C15.248 11.93 13.887 12.112 13.012 13.032L14.1 14.064Z"
                    fill="white"
                  />
                </svg>
              )}
              {data?.expense_category === "software license" && (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 8H20.5M6 5H6.009M10 5H10.009M1.5 11C1.5 6.522 1.5 4.282 2.891 2.891C4.282 1.5 6.521 1.5 11 1.5C15.478 1.5 17.718 1.5 19.109 2.891C20.5 4.282 20.5 6.521 20.5 11C20.5 15.478 20.5 17.718 19.109 19.109C17.718 20.5 15.479 20.5 11 20.5C6.522 20.5 4.282 20.5 2.891 19.109C1.5 17.718 1.5 15.479 1.5 11Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 12L8.227 13.057C8.742 13.502 9 13.724 9 14C9 14.276 8.742 14.498 8.227 14.943L7 16M11 16H15"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
              {![
                "flight",
                "hotel",
                "transportation",
                "meal",
                "office supplies",
                "cell phone plan",
                "software license",
              ].includes(data?.expense_category) && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
            <div className="flex flex-col">
              <span className="text-primary !font-medium !text-left">
                {data?.expense_name}
              </span>
              <span className="text-secondary !text-left capitalize">
                {data?.expense_category}
              </span>
            </div>
          </div>

          <div className="flex h-[40px] justify-end items-center">
            <svg
              onClick={() => {
                setShow(!show);
              }}
              className="cursor-pointer"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.5001 3.08984L15.0001 7.58984V3.99984H13.0001V10.9998H20.0001V8.99984H16.4101L20.9101 4.49984L19.5001 3.08984ZM4.00009 12.9998V14.9998H7.59009L3.09009 19.4998L4.50009 20.9098L9.00009 16.4098V19.9998H11.0001V12.9998H4.00009Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="h-[2px] bg-[#41485C] absolute left-[24px] right-[24px]" />
      </div>

      <div className="flex flex-col p-3 md:px-[24px] md:py-[24px] gap-3 md:gap-[24px]">
        <div className="w-full flex flex-col pb-[8px]">
          <div className="flex items-center">
            <span className="text-primary !text-left !text-[24px] !leading-[36px] mb-[10px]">
              {submission?.service_name}
            </span>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Cost</span>
            </div>
            <div>
              <span className="text-primary !text-left !font-normal !text-[14px]">
                {formatFunction(data?.cost)}
              </span>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Employee</span>
            </div>
            <div className="flex gap-2  items-center">
              <div className="rounded-full bg-[#2284FF]/[15%] to-white !text-[#2284FF] !text-[11px] !text-center w-[24px] h-[24px] text-primary flex justify-center items-center pl-[2px] pt-[1px]">
                {initials}
              </div>
              <div>
                <span className="text-primary !text-left !font-normal !text-[14px]">
                  {data?.employee_name} - {data?.employee_role}
                </span>
              </div>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">Reason</span>
            </div>
            <div>
              <p className="text-primary !text-left !font-normal !text-[14px] max-w-[300px]">
                {data?.reason}
              </p>
            </div>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">
                Transaction date
              </span>
            </div>
            <span className="text-primary !text-left !font-normal !text-[14px]">
              {data?.transaction_date}
            </span>
          </div>

          <div className="flex py-[8px] gap-[4px] items-center justify-left">
            <div className="w-[156px] h-[20px] flex items-center !text-left">
              <span className="text-secondary !leading-[20px]">
                Expensed date
              </span>
            </div>
            <div className="flex gap-[4px]">
              <span className="text-primary !text-left !font-normal !text-[14px]">
                {data?.expensed_date}
              </span>
            </div>
          </div>
        </div>

        <div className="w-full h-[2px] bg-[#41485C]" />

        <div className="flex flex-col gap-3 md:gap-[24px]">
          <div className=" flex flex-col h-auto overflow-y-auto scrollbar-hide gap-[12px]">
            <div className="flex w-full gap-[4px] items-center bg-[#363D50]">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.25 1.25C6.5266 1.25165 4.87426 1.93701 3.65563 3.15563C2.43701 4.37426 1.75165 6.0266 1.75 7.75V13.0188C1.75 13.3453 1.87972 13.6585 2.11062 13.8894C2.34153 14.1203 2.6547 14.25 2.98125 14.25H8.25C9.97391 14.25 11.6272 13.5652 12.8462 12.3462C14.0652 11.1272 14.75 9.47391 14.75 7.75C14.75 6.02609 14.0652 4.37279 12.8462 3.15381C11.6272 1.93482 9.97391 1.25 8.25 1.25ZM8.25 12.75H3.25V7.75C3.25 6.76109 3.54324 5.79439 4.09265 4.97215C4.64206 4.1499 5.42295 3.50904 6.33658 3.1306C7.25021 2.75216 8.25555 2.65315 9.22545 2.84607C10.1954 3.039 11.0863 3.5152 11.7855 4.21447C12.4848 4.91373 12.961 5.80464 13.1539 6.77455C13.3469 7.74445 13.2478 8.74979 12.8694 9.66342C12.491 10.577 11.8501 11.3579 11.0279 11.9073C10.2056 12.4568 9.23891 12.75 8.25 12.75ZM10.75 6.75C10.75 6.94891 10.671 7.13968 10.5303 7.28033C10.3897 7.42098 10.1989 7.5 10 7.5H6.25C6.05109 7.5 5.86032 7.42098 5.71967 7.28033C5.57902 7.13968 5.5 6.94891 5.5 6.75C5.5 6.55109 5.57902 6.36032 5.71967 6.21967C5.86032 6.07902 6.05109 6 6.25 6H10C10.1989 6 10.3897 6.07902 10.5303 6.21967C10.671 6.36032 10.75 6.55109 10.75 6.75ZM10.75 9.25C10.75 9.44891 10.671 9.63968 10.5303 9.78033C10.3897 9.92098 10.1989 10 10 10H6.25C6.05109 10 5.86032 9.92098 5.71967 9.78033C5.57902 9.63968 5.5 9.44891 5.5 9.25C5.5 9.05109 5.57902 8.86032 5.71967 8.71967C5.86032 8.57902 6.05109 8.5 6.25 8.5H10C10.1989 8.5 10.3897 8.57902 10.5303 8.71967C10.671 8.86032 10.75 9.05109 10.75 9.25Z"
                  fill="#A5AEBC"
                />
              </svg>
              <div className="flex items-center">
                <span className="text-secondary !text-left !text-[11px] !font-semibold">
                  COMMENTS
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-[12px]">
              {userExpensesComment.length > 0 &&
                userExpensesComment.map((item) => (
                  <div
                    key={item.commented_on}
                    className="flex flex-start gap-[10px]"
                  >
                    <div className="w-[40px] h-[40px] flex justify-center items-center rounded-full bg-[#BD3CFF] bg-opacity-20">
                      <span className="flex w-[40px] h-[40px] items-center justify-center text-primary !text-[14px] !font-semibold !text-[#BD3CFF]">
                        <span>{getInitials(item.commented_by)}</span>
                      </span>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex gap-[4px]">
                        <span className="text-secondary !text-left !text-[#FFFFFF] !font-medium !leading-[21px]">
                          {item.commented_by}
                        </span>
                        <span className="text-secondary !text-left !font-medium !leading-[21px]">
                          {formatDate(item.commented_on)}
                        </span>
                      </div>
                      <span className="text-secondary !text-left">
                        {item.content}
                      </span>
                    </div>
                  </div>
                ))}
            </div>

            <div className="w-full flex flex-col p-4 border-[1px] border-[#596073] rounded-[16px]">
              <textarea
                className="!h-[100px] p-0 scrollbar-hide w-full resize-none border-none focus:ring-0 bg-[#363D50]"
                onChange={(e) => {
                  setWords(e.target.value);
                }}
                onKeyDown={handleKeyDown}
                placeholder={"Write comment"}
                value={Words}
              />
              <hr className="border-[#41485C]" />
              <div className="flex justify-between pt-[17px]">
                <span className="text-secondary text-left">
                  {Words.length}/500
                </span>
                <Button
                  onClick={postComment}
                  className={"!w-[fit-content] !h-[fit-content]"}
                  secondary={true}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpenseInfoModel;
